export const ROLE_CREATE_RESET = 'ROLE_CREATE_RESET'
export const ROLE_CREATE_SET_CREATED = 'ROLE_CREATE_SET_CREATED'
export const ROLE_CREATE_SET_ERROR = 'ROLE_CREATE_SET_ERROR'
export const ROLE_CREATE_SET_VIOLATIONS = 'ROLE_CREATE_SET_VIOLATIONS'
export const ROLE_CREATE_TOGGLE_LOADING = 'ROLE_CREATE_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/role/create/mutation_types.js